(function () {
  class ProductGameVideo {
    constructor(section) {
      this.section = section;
      this.video = section.querySelector('[data-pgv-video]');
      this.playButton = section.querySelector('[data-pgv-play]');

      if (!this.video || !this.playButton) return;

      this.video.setAttribute('controlsList', 'nodownload');

      this.playButton.addEventListener('click', () => this.play());
      this.video.addEventListener('play', () => this.section.classList.add('is-playing'));
      this.video.addEventListener('pause', () => {
        if (!this.video.ended && this.video.currentTime > 0) return;
        this.section.classList.remove('is-playing');
      });
      this.video.addEventListener('ended', () => this.section.classList.remove('is-playing'));
    }

    play() {
      this.video.controls = true;
      this.video.play().catch(() => {
        this.video.controls = true;
      });
    }
  }

  function initProductGameVideos(scope) {
    (scope || document).querySelectorAll('[data-product-game-video]').forEach((section) => {
      if (section.dataset.productGameVideoReady === 'true') return;
      section.dataset.productGameVideoReady = 'true';
      new ProductGameVideo(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductGameVideos(document));
  document.addEventListener('shopify:section:load', (event) => initProductGameVideos(event.target));
})();
